import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, MailCheck } from "lucide-react";
import Logo from "@/components/Logo";
import api from "@/lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch {
      setSent(true); // generic — never reveal whether the account exists
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10">
      <Logo size="lg" tagline />
      <div className="sms-tweed rounded-3xl border-2 border-[#5d8a52] bg-[#0f0f16] w-full max-w-sm p-6 mt-8 sms-fade-up text-white">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="w-14 h-14 rounded-2xl mx-auto flex items-center justify-center mb-4" style={{ background: "#12241a", border: "2px solid #5d8a52" }}>
              <MailCheck size={26} className="text-[#a9d79b]" />
            </div>
            <h2 className="text-lg font-extrabold mb-1 text-white">Check your inbox</h2>
            <p className="text-sm text-white/60">If that address is in our system, a reset link is on its way. It expires in 30 minutes.</p>
            <button
              data-testid="back-to-login-btn"
              onClick={() => navigate("/login")}
              className="sms-solid-btn w-full text-white font-bold py-3 rounded-2xl mt-5"
            >
              Back to log in
            </button>
          </div>
        ) : (
          <>
            <button onClick={() => navigate("/login")} className="flex items-center gap-1.5 text-sm font-semibold text-white/60 hover:text-[#a9d79b] mb-3">
              <ArrowLeft size={15} /> Back
            </button>
            <h2 className="text-xl font-extrabold text-white">Forgot your password?</h2>
            <p className="text-sm text-white/60 mt-1 mb-5">Enter your email and we'll send you a link to set a new one.</p>
            <form onSubmit={submit}>
              <div className="relative">
                <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40" />
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="w-full rounded-2xl bg-black text-white placeholder:text-white/40 pl-10 pr-4 py-3 outline-none border-2 border-[#5d8a52]"
                />
              </div>
              <button
                data-testid="forgot-submit-btn"
                type="submit"
                disabled={busy}
                className="sms-solid-btn w-full text-white font-bold py-3 rounded-2xl mt-4 flex items-center justify-center gap-2 disabled:opacity-70"
              >
                {busy && <Loader2 size={16} className="spin" />} Send reset link
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
